/**
 * TaskReportService
 * Service for admin task reporting and analytics.
 * Route: api/tasks/reports
 */
export class TaskReportService {
    constructor(http, config) {
        this.http = http;
        this.basePath = config?.basePath ?? 'api/tasks/reports';
    }
    buildUrl(endpoint) {
        return `/${this.basePath}/${endpoint}`.replace(/\/+/g, '/');
    }
    /**
     * Get aggregate report summary.
     */
    async getSummary(filter) {
        const response = await this.http.post(this.buildUrl('summary'), filter ?? {});
        return response.data;
    }
    async getSummaryRaw(filter) {
        return this.http.post(this.buildUrl('summary'), filter ?? {});
    }
    /**
     * Get per-user task statistics.
     */
    async getByUser(filter) {
        const response = await this.http.post(this.buildUrl('by-user'), filter ?? {});
        return response.data ?? [];
    }
    async getByUserRaw(filter) {
        return this.http.post(this.buildUrl('by-user'), filter ?? {});
    }
    /**
     * Get per-location task statistics.
     */
    async getByLocation(filter) {
        const response = await this.http.post(this.buildUrl('by-location'), filter ?? {});
        return response.data ?? [];
    }
    async getByLocationRaw(filter) {
        return this.http.post(this.buildUrl('by-location'), filter ?? {});
    }
    /**
     * Get per-department task statistics.
     */
    async getByDepartment(filter) {
        const response = await this.http.post(this.buildUrl('by-department'), filter ?? {});
        return response.data ?? [];
    }
    async getByDepartmentRaw(filter) {
        return this.http.post(this.buildUrl('by-department'), filter ?? {});
    }
    /**
     * Get per-project task statistics.
     */
    async getByProject(filter) {
        const response = await this.http.post(this.buildUrl('by-project'), filter ?? {});
        return response.data ?? [];
    }
    async getByProjectRaw(filter) {
        return this.http.post(this.buildUrl('by-project'), filter ?? {});
    }
    /**
     * Get task trend data (created/completed over time).
     */
    async getTrends(filter) {
        const response = await this.http.post(this.buildUrl('trends'), filter ?? {});
        return response.data ?? [];
    }
    async getTrendsRaw(filter) {
        return this.http.post(this.buildUrl('trends'), filter ?? {});
    }
}
//# sourceMappingURL=TaskReportService.js.map